import { BasePayloadMapper } from '@ps/utils';

import { TemplateSurveyPayloadDto } from '../dtos/survey.dto';

const PLATFORM_SOURCE = 'platform';

export interface TemplateSurveyPayloadInput {
  templateId: number;
  userId: number;
  companyId: number;
}

export class TemplateSurveyPayloadMapper extends BasePayloadMapper<
  TemplateSurveyPayloadInput,
  TemplateSurveyPayloadDto
> {
  public toPayload({
    templateId,
    userId,
    companyId,
  }: TemplateSurveyPayloadInput): TemplateSurveyPayloadDto {
    return {
      source: PLATFORM_SOURCE,
      buyer_user_id: userId,
      buyer_company: companyId,
      template_id: templateId,
    };
  }
}
